// src/App.js (Mise à jour pour utiliser le Layout)
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
import Layout from './Layout'; // Import du composant Layout
import Home from './Home';      // Contenu de la page d'accueil (Sections uniquement)
import Login from './pages/Login'; 
import { useTranslation } from 'react-i18next';

function LoadingScreen() {
  return (
    <div
      className="loading-screen"
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.2em',
        color: '#0047AB'
      }}
    >
      Chargement de l'application...
    </div>
  );
}

function App() {
  const { i18n } = useTranslation();

  if (!i18n.isInitialized) {
    return <LoadingScreen />;
  }

  return (
    <BrowserRouter> 
      <Routes>
        {/* ROUTE PARENT : Le chemin "/" affiche le composant Layout */}
        <Route path="/" element={<Layout />}>
            {/* ROUTE ENFANT : Le chemin exact "/" affiche le contenu de Home dans le <Outlet> du Layout */}
            <Route index element={<Home />} />
            
            {/* ROUTE ENFANT : Le chemin "/login" affiche le contenu de Login dans le <Outlet> du Layout */}
            <Route path="login" element={<Login />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;